import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/custom-terms/{id}']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const createCustomTermsFromInstance = async ({ data, deviceFingerprint, id }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.put(`/custom-terms/${id}`, { data, deviceFingerprint });
  return response.data;
};

export default createCustomTermsFromInstance;
